export enum ContentType {
  QUESTION_SET = 'Question Set',
  CROSSWORD = 'Crossword',
  DIALOG_CARDS = 'Dialog Cards',
  DRAG_THE_WORDS = 'Drag the Words',
  FILL_IN_THE_BLANKS = 'Fill in the Blanks',
  MARK_THE_WORDS = 'Mark the Words',
  MULTIPLE_CHOICE = 'Multiple Choice',
  TRUE_FALSE_QUESTION = 'True/False Question',
}
